export { OrderStatuses } from "utilities/dist/order/constants";

export const ORDER_GRID_DATA = "ORDER_GRID_DATA";
export const ORDER_GRID_ERROR = "ORDER_GRID_ERROR";
export const ORDER_GRID_LOADING = "ORDER_GRID_LOADING";
export const ORDER_GRID_PAGE_CHANGE = "ORDER_GRID_PAGE_CHANGE";
export const ORDER_GRID_STATE_CHANGE = "ORDER_GRID_STATE_CHANGE";
export const ORDER_BUILDER_SAVING = "ORDER_BUILDER_SAVING";
export const ORDER_BUILDER_SAVED = "ORDER_BUILDER_SAVED";
